/**
 * Wraps the public creator profile so that navigation is consistent for logged-in users.
 * - Logged out: render PublicProfile with its own header (Log in / Create your media kit).
 * - Logged in brand: render BrandTopTabs (Dashboard | Profile | Avatar | Logout) + profile content.
 * - Logged in creator: render DashboardShell (Profile tab + Avatar | Logout) + profile content.
 * Navigation is determined by authentication state, not by route.
 */

import React from 'react';
import { useAuth } from '../../context/AuthContext.jsx';
import PublicProfile from '../../pages/PublicProfile';
import BrandTopTabs from '../brand/BrandTopTabs';
import DashboardShell from './DashboardShell';

export default function PublicProfileWithLayout({ username, onNavigate }) {
  const { user, profile } = useAuth();

  const isAuthenticated = !!(user && profile);

  if (!isAuthenticated) {
    return <PublicProfile username={username} onNavigate={onNavigate} />;
  }

  const isBrand = profile?.userType === 'brand';

  if (isBrand) {
    return (
      <>
        <BrandTopTabs
          onNavigate={onNavigate}
          activeTab={null}
          brandProfile={profile}
        />
        <main className="min-h-screen bg-[#FAFAFA]">
          <PublicProfile username={username} onNavigate={onNavigate} skipAppHeader />
        </main>
      </>
    );
  }

  return (
    <DashboardShell onNavigate={onNavigate}>
      <PublicProfile username={username} onNavigate={onNavigate} skipAppHeader />
    </DashboardShell>
  );
}
